export default {
  startLoading: 'Rozpocznij załadunek',
  finishLoading: 'Zakończ załadunek',
  loadEditDisabled: 'Można edytować tylko obciążenie "planowane".',
  startLoad: 'Rozpocznij wsad',
  confirmStartLoad: 'Rozpocząć wsad "{load}"?',
  confirmStartLoading: 'Rozpocząć załadunek "{load}"?',
  confirmFinishLoading: 'Zakończyć załadunek "{load}"?',
};
